export const ASSIGN_BOOK_REQUEST = 'ASSIGN_BOOK_REQUEST'
export const ASSIGN_BOOK_SUCCESS = 'ASSIGN_BOOK_SUCCESS'
export const ASSIGN_BOOK_FALIURE = 'ASSIGN_BOOK_FALIURE'
